import axios from 'axios';

const httpPost = async (
  url: string,
  data: any,
  headers?: any,
  formData?: any
) => {
  const response = await axios.post(url, formData ?? { ...data }, {
    ...headers
  });
  return response;
};

export default httpPost;
